import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const ComplianceSection = () => {
    return (
        <Box
            component="section"
            id="problem"
            aria-labelledby="problem-section-heading"
            sx={{
                position: 'relative',
                pt: { xs: 7, md: 7.5, lg: 8 },
                pb: { xs: 4, md: 4.5, lg: 4.5 },
                px: 0,
                background: 'linear-gradient(180deg, #151821 0%, #1A1F2E 45%, #161A24 100%)',
                borderTop: '1px solid rgba(255, 255, 255, 0.06)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 'min(100%, 900px)',
                    height: '320px',
                    background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(0, 102, 255, 0.07) 0%, transparent 65%)',
                    pointerEvents: 'none',
                },
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto'}}>    
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        COMPLIANCE
                    </Typography>
                </Box>
                <Typography
                    id="problem-section-heading"
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem', lg: '2.75rem' },
                        fontWeight: 700,
                        lineHeight: 1.2,
                        letterSpacing: '-0.03em',
                        color: '#F1F5F9',
                        mb: { xs: 3, md: 4 },
                        // maxWidth: '18ch',
                        textAlign: 'center',
                        mx: 'auto',
                    }}
                >
                    If you were audited tomorrow
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(226, 232, 240, 0.88)',
                        fontWeight: 400,
                        // maxWidth: '42rem',
                        textAlign: 'justify',
                        mb: { xs: 3.5, md: 4 },
                        mx: 'auto',
                    }}
                >
                    Every session is retrievable on demand. Patient data sits in encrypted records, not on a therapist's personal WhatsApp. Consent is documented before the first session starts. Privacy practices are enforced by the system. Access is role-based - therapists see their own patients, admins see across the team.
                    <br />
                    Most centers haven't calculated their exposure yet. On meDZhub, when the question comes up - from an auditor, an insurer, or a patient - the answer is already in the system.
                </Typography>
            </Container>
        </Box>
    );
};

export default ComplianceSection;
